import axios from "axios";
import { Dispatch } from "redux";
import {
  GET_ALL_PAYMENT,
  GET_ALL_PAYMENT_SUCCESS,
  GET_ALL_PAYMENT_FAILURE,
  RESET_PAYMENT,
  PaymentActionTypes,
  GET_PAYMENT_METHODS,
  GET_PAYMENT_METHODS_SUCCESS,
  GET_PAYMENT_METHODS_FAILURE,
} from "../types/paymentTypes";

const API = axios.create({ baseURL: process.env.REACT_APP_API_URL });

API.defaults.withCredentials = true;

export const getAllPayment =
  (data: any) => async (dispatch: Dispatch<PaymentActionTypes>) => {
    try {
      dispatch({ type: GET_ALL_PAYMENT, payload: [] });

      const response = await API.get("/payments", {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        params: {
          page: data?.page,
          itemsPerPage: data?.itemsPerPage,
        },
      });

      if (response.status) {
        dispatch({ type: GET_ALL_PAYMENT_SUCCESS, payload: response.data });
      } else {
        dispatch({
          type: GET_ALL_PAYMENT_FAILURE,
          payload: response.data.message,
        });
      }
    } catch (error: any) {
      const status = error?.response?.status;
      if (status === 401) {
        localStorage.removeItem("token");
        window.location.href = "/login";
        return;
      }

      dispatch({
        type: GET_ALL_PAYMENT_FAILURE,
        payload: error?.response?.data?.message,
      });
    }
  };

export const getPaymentMethods =
  () => async (dispatch: Dispatch<PaymentActionTypes>) => {
    try {
      dispatch({ type: GET_PAYMENT_METHODS, payload: [] });
      const response = await API.get("/payment-methods/active");

      if (response.status) {
        dispatch({ type: GET_PAYMENT_METHODS_SUCCESS, payload: response.data });
      } else {
        dispatch({
          type: GET_PAYMENT_METHODS_FAILURE,
          payload: response.data.message,
        });
      }
    } catch (error: any) {
      dispatch({
        type: GET_PAYMENT_METHODS_FAILURE,
        payload: error?.response?.data?.message,
      });
    }
  };

export const resetPayment = () => (dispatch: Dispatch<PaymentActionTypes>) => {
  dispatch({ type: RESET_PAYMENT });
};
